import { createStyles, makeStyles } from '@material-ui/styles';

export const containerStyle = makeStyles(() => createStyles({
  root: {
    height: 'auto',
  }
}))
